import { startClarity } from "../lib/clarity"

startClarity()
